export default "__VITE_ASSET__CDl29URC__"